import { z } from 'zod';
import LangEnum from '../../../../lang/LangEnum';
import { MIN_PASSWORD_LENGTH } from '../../../../utils/constants';
import { BuildCreateAccountValidationSchemaParams } from '../../types/createAccount.types';

export const buildCreateAccountValidationSchema = ({
  translate,
  storeCountryCode,
}: BuildCreateAccountValidationSchemaParams) => {
  const minLengthMessage = translate(LangEnum.PROFILE_USER_FORM_PASSWORD_VALIDATION, {
    min: MIN_PASSWORD_LENGTH,
  });

  return z
    .object({
      name: z.string().trim().min(1, translate(LangEnum.GLOBAL_REQUIRED)),
      surname: z.string().trim().min(1, translate(LangEnum.GLOBAL_REQUIRED)),
      email: z
        .string()
        .trim()
        .min(1, translate(LangEnum.GLOBAL_REQUIRED))
        .pipe(z.email(translate(LangEnum.GLOBAL_INVALID_EMAIL))),
      password: z
        .string()
        .trim()
        .min(1, translate(LangEnum.GLOBAL_REQUIRED))
        .min(MIN_PASSWORD_LENGTH, minLengthMessage),
      confirmPassword: z
        .string()
        .trim()
        .min(1, translate(LangEnum.GLOBAL_REQUIRED))
        .min(MIN_PASSWORD_LENGTH, minLengthMessage),
      countryCode: z.string().trim(),
      phone: z.string().trim(),
    })
    .superRefine((values, context) => {
      if (values.confirmPassword !== values.password) {
        context.addIssue({
          code: 'custom',
          path: ['confirmPassword'],
          message: translate(LangEnum.PROFILE_USER_FORM_DIFFERENT_PASSWORDS),
        });
      }

      const countryCode = values.countryCode || storeCountryCode || '';

      if (!values.phone.slice(countryCode.length)) {
        context.addIssue({
          code: 'custom',
          path: ['phone'],
          message: translate(LangEnum.GLOBAL_REQUIRED),
        });
      }
    });
};

export type CreateAccountValidationSchema = ReturnType<typeof buildCreateAccountValidationSchema>;

export type CreateAccountFormValues = z.infer<CreateAccountValidationSchema>;
